export const referEarnWhitePageBgImage = require('./white-theme-assets/page-bg.webp');
export const referEarnWhiteReferralPageBgImage = require('./white-theme-assets/referral-page-bg.webp');
export const referEarnWhitePanelBgImage = require('./white-theme-assets/panel-bg.webp');
export const referEarnWhiteAgentTreeImage = require('./white-theme-assets/agent-tree.webp');
export const referEarnWhiteRewardModalBgImage = require('./white-theme-assets/reward-modal-bg.png');
export const referEarnWhiteRewardCoinImage = require('@/assets/figma/20pan/random-reward-coin.webp');
export const referEarnWhiteRewardDecorImage = require('./white-theme-assets/reward-raw-1.png');
export const referEarnWhiteCongratsNodeImage = require('./white-theme-assets/congrats-node.png');
export const referEarnWhiteCashTitleArrowImage = require('./white-theme-assets/cash-title-arrow.png');
